//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../Features/Features.SelectionProgramListItemBuilderList.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectBodyList.js";
import "../no/SelectGroupList.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"CollectionType",1,0],[1,"ProgramList",0,"Features.SelectionProgramListItemBuilderList",0],[1,"RejectedDomainEntities",0,"SelectNXObjectList",0],[1,"SelectBody",0,"SelectBodyList",0],[1,"SelectFeature",0,"SelectNXObjectList",0],[1,"SelectGroup",0,"SelectGroupList",0],[0,"SelectionIntent",1,0]],[[["listBuilder"],"RemoveProgramListItem",{},1,0]],[]];
SPLM.Features.SelectionProgramMainBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SelectionProgramMainBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SelectionProgramMainBuilder.CollectionTypes = Object.freeze({
    "Body" : "Body", "Face" : "Face", "Edge" : "Edge", "Curve" : "Curve", "Point" : "Point", "Invalid" : "Invalid"});

SPLM.Features.SelectionProgramMainBuilder.SelectionIntentTypes = Object.freeze({
    "FeatureBodies" : "FeatureBodies", "GroupBodies" : "GroupBodies", "BodyFaces" : "BodyFaces", "FeatureFaces" : "FeatureFaces", "BodyEdges" : "BodyEdges", "SheetEdges" : "SheetEdges", "FeatureIntersectionEdges" : "FeatureIntersectionEdges", "FeatureCurves" : "FeatureCurves", "GroupCurves" : "GroupCurves", "FeaturePoints" : "FeaturePoints", "Invalid" : "Invalid"});

export default SPLM;